export const setQueues = (queues) => ({
    type: "SET_QUEUES",
    payload: queues,
  });
